var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{attrs:{"src":_setup.srcValue,"srcset":_setup.srcset,"alt":_vm.alt,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }